import { adminRequestsTyped } from "@/api/(requests)/adminTyped";
import type { GetAllPracticesResponse } from "@/core/types/(api)/practice";

export async function getPracticeList(): Promise<GetAllPracticesResponse> {
  return adminRequestsTyped.fetch_all_practices();
}
